import React from "react";
import "./FooterMobile.css";
import {useHistory} from "react-router-dom";


const FooterMobile = (props) => {
    const history = useHistory();
    return (
        <React.Fragment>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "100%",
                    marginTop:"248px"
                }}
            >
                <div style={{marginTop: "30px"}}>
                    <button className="btn_ing font-face-poppins-bold"
                            style={{
                                width: "100%",
                            }} onClick={() => history.push({
                        pathname: `/a/${props.CodigoProductor}/${props.affinityId}/productos`
                    })}>ACTIVÁ TUS BENEFICIOS
                    </button>
                </div>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        width: "100%",
                        marginTop: "20px",

                    }}
                >

                </div>
            </div>
        </React.Fragment>
    );
};

export default FooterMobile;
